
export default {
	components: {},
	
	props: {
		img: Object
	}
}
